import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';

import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

@Injectable()

export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private toastr: ToastrService,
        private _router: Router,
    ){}
    
    intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
        return next.handle(request)
        .pipe(
            catchError(
                err => {
                    console.log(err);
                    let errorStatus = err.statusText ? err.statusText : 'Unidentified Error';
                    let errorMessage = err.error.error ? err.error.error : 'Error processing request.';
                    if(err.status === 401){
                        this.authService.logout();
                        this._router.navigate(['/login']).then(() => {
                            this.toastr.info(`${errorStatus}: ${errorMessage}`, "Requiere autenticación.");
                        });
                        return throwError(err);
                    }
                    this.toastr.error(errorStatus, errorMessage);
                    
                    return throwError(err);
                }
            )
        )
    }
}